
export default class TaxModel {
    constructor (_code = 1, _name = "",_description = "", _rate = "",
                   _permission = { id: 0, name: 'No'}, _permissionCost = '0', _status = { id: 1, name: 'Activo'}) {
      this.code   = _code;
      this.name = _name;
      this.description = _description;
      this.rate = _rate,
      this.permission = _permission;
      this.permissionCost = _permissionCost;
      this.status   = _status;
    }
  }
  